import { Button, Stack } from "@mantine/core";
import { useEffect, useState } from "react";
import { Link } from "react-router";
import api from "../../../api";
import { useToast } from "../../../mantine/notifications/useToast";
import urls from "../../../urls";
import { useHistoricalDataImportState } from "../utils/useHistoricaDataImportState";
import {
  HistoricalDataImport,
  IMPORT_RUNNING_TEXT
} from "./HistoricalDataImport";

interface HistoricalDataImportWithSubmitProps {
  id: number;
}

function HistoricalDataImportWithSubmit({
  id: configurationId
}: HistoricalDataImportWithSubmitProps) {
  const { showToast, showErrorToast } = useToast();
  const [startDate, endDate, setDates] = useHistoricalDataImportState();
  const [loading, setLoading] = useState(false);
  const [imported, setImported] = useState(false);

  useEffect(() => {
    setImported(false);
  }, [startDate, endDate]);

  function handleClickSubmit() {
    setLoading(true);

    api
      .post(
        urls.api.subMeteringConfigurationHistoricalDataImport(configurationId),
        { start: startDate, end: endDate }
      )
      .then(() => {
        setImported(true);
        showToast({ type: "success", message: IMPORT_RUNNING_TEXT });
      })
      .catch((error) => {
        showErrorToast(error);
      })
      .finally(() => {
        setLoading(false);
      });
  }

  const canSubmit = !!startDate && !!endDate && !imported;

  return (
    <Stack align="center">
      <HistoricalDataImport onDatesChanged={setDates} />
      <Stack gap="xs" w={200}>
        <Button
          color="primary"
          disabled={!canSubmit}
          loading={loading}
          onClick={handleClickSubmit}
        >
          Importieren
        </Button>

        {imported && (
          <Button
            color="secondary"
            component={Link}
            to={`../../${configurationId}/historie`}
          >
            Import-Historie anzeigen
          </Button>
        )}
      </Stack>
    </Stack>
  );
}

export { HistoricalDataImportWithSubmit, HistoricalDataImportWithSubmitProps };
